import { Box, Grid } from "@mui/material";

import { wallets, BUYER } from "../constants";

import "../styles.css";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const RefundBuyer = (props: any) => {
  const { type, transactionsInfo } = props;

  return (
    <>
      <Grid
        item
        md={2}
        sx={{ display: { xs: "none", sm: "block" } }}
        className="trans-center">
        <Box component="img" src="/assets/images/svg/BankTrans.svg" />
      </Grid>
      <Grid item md={6} xl={6} sx={{ display: { xs: "block", sm: "block" } }}>
        <span className="trans-title">
          {type === BUYER
            ? wallets.PAYMENT_CUSTOMER_REFUND +
              " " +
              transactionsInfo.amount +
              wallets.PAYMENT_CUSTOMER_REFUND_TEXT +
              transactionsInfo.beneficiaryName
            : wallets.SELLER_PAYMENT_CUSTOMER_REFUND +
              " " +
              transactionsInfo.amount +
              wallets.SAR +
              wallets.SELLER_PAYMENT_CUSTOMER_REFUND_TEXT}
        </span>
      </Grid>
    </>
  );
};
export default RefundBuyer;
